module.exports = __webpack_public_path__ + "img/icon-warning-drivingconditions-red.236632c6.svg";